export default __webpack_public_path__ + "static/media/Youth_Illustrations-Arche.9d5b243a.png";